import React, { useState, useEffect } from 'react';
import { ChevronDown } from "lucide-react";
import { useNavigate } from 'react-router-dom';

const QUOTE_ID = 'S8ngm39Flp04bf';

const Accordion = ({ title, children, onOpen }) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleToggle = () => {
        const next = !isOpen;
        setIsOpen(next);

        if (next && onOpen) {
            onOpen(title);
        }
    };
    return (
        <div className={`accordion ${isOpen ? "open" : ""}`}>
            <button className="accordion-trigger" onClick={handleToggle}>
                <h3>{title}</h3>
                <ChevronDown className={`accordion-icon ${isOpen ? "rotated" : ""}`} />
            </button>
            {isOpen && <>{children}</>}
        </div>
    );
};

export default function Quote_S8ngm39Flp04bf() {
    const navigate = useNavigate();
    const [input, setInput] = useState('');
    const [unlocked, setUnlocked] = useState(false);
    const [error, setError] = useState('');
    const [suppressNotifications, setSuppressNotifications] = useState('');

    const [quoteData, setQuoteData] = useState(null);

    useEffect(() => {
        fetch(`/api/quoteRoute/${QUOTE_ID}`)
            .then(r => r.json())
            .then(setQuoteData);
    }, []);

    const unlock = (suppressNotification = false, meta = {}) => {
        setUnlocked(true);
        setSuppressNotifications(suppressNotification);

        if (suppressNotification) return;

        fetch('/api/quoteRoute/viewed', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                quoteId: QUOTE_ID,
                unlockMethod: meta.method,
                unlockValue: meta.value
            })
        }).catch(() => { });
    };

    const trackAccordionOpen = (sectionTitle) => {
        fetch('/api/quoteRoute/interaction', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                quoteId: QUOTE_ID,
                type: 'accordion_open',
                section: sectionTitle
            })
        }).catch(() => { });
    };

    if (!unlocked) {
        return (
            <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f9fafb' }}>
                <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '2rem', width: '100%', maxWidth: '380px', textAlign: 'center' }}>
                    <img src='/transparent-logo-min.png' alt='Logo' style={{ width: '100%', marginBottom: '1rem' }} />
                    <h2 style={{ marginBottom: '0.25rem' }}>Your Quote</h2>
                    <p style={{ color: '#6b7280', marginBottom: '1.5rem', fontSize: '0.9rem' }}>North Florida Home Repair & Maintenance</p>
                    <input
                        type="text"
                        placeholder="Enter your access code"
                        value={input}
                        onChange={e => setInput(e.target.value)}
                        onKeyDown={e => {
                            if (e.key === 'Enter') {
                                const cleaned = input.replace(/\D/g, '') || input.trim();
                                const normalize = v => v?.replace(/\D/g, '') || v?.trim();

                                const phone1 = normalize(quoteData?.clientPhone);
                                const phone2 = normalize(quoteData?.clientPhone2);
                                const password = normalize(quoteData?.customPassword);

                                if (cleaned === '1131') {
                                    unlock(true, { method: 'override', value: cleaned });
                                } else if (cleaned === phone1) {
                                    unlock(false, { method: 'clientPhone', value: cleaned });
                                } else if (cleaned === phone2) {
                                    unlock(false, { method: 'clientPhone2', value: cleaned });
                                } else if (cleaned === password) {
                                    unlock(false, { method: 'customPassword', value: cleaned });
                                } else {
                                    setError('Incorrect. Try again.');
                                }
                            }
                        }}
                        style={{ padding: '0.5rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '0.95rem', width: '100%', boxSizing: 'border-box', marginBottom: '0.5rem' }}
                    />
                    {error && <p style={{ color: '#ef4444', fontSize: '0.875rem', margin: '0 0 0.5rem' }}>{error}</p>}
                    <button
                        onClick={() => {
                            const cleaned = input.replace(/\D/g, '') || input.trim();
                            const normalize = v => v?.replace(/\D/g, '') || v?.trim();

                            const phone1 = normalize(quoteData?.clientPhone);
                            const phone2 = normalize(quoteData?.clientPhone2);
                            const password = normalize(quoteData?.customPassword);

                            if (cleaned === '1131') {
                                unlock(true, { method: 'override', value: cleaned });
                            } else if (cleaned === phone1) {
                                unlock(false, { method: 'clientPhone', value: cleaned });
                            } else if (cleaned === phone2) {
                                unlock(false, { method: 'clientPhone2', value: cleaned });
                            } else if (cleaned === password) {
                                unlock(false, { method: 'customPassword', value: cleaned });
                            } else {
                                setError('Incorrect. Try again.');
                            }
                        }}
                        style={{ background: '#111827', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.65rem 1.25rem', fontSize: '0.95rem', cursor: 'pointer', width: '100%' }}
                    >
                        View quote
                    </button>
                </div>
            </div>
        );
    }
    return (
        <div className='app'>
            <main className='page' style={{ paddingTop: 0 }}>
                <section className='section section-about'>
                    <div className='hero'>
                        <img src='/jax_small.jpg' alt='Logo' className='hero-image' />
                        <div className='hero-overlay'>
                            <div className='hero-text-box'>
                                <div className='hero-title-main'>North Florida</div>
                                <div className='hero-title-sub'>Home Repair & Maintenance</div>
                            </div>
                        </div>
                    </div>

                    <div className='custom-quote'>
                        <div className="quote-subsection" style={{ borderBottom: '2px solid #111827' }}>
                            <p>Thank you again for the opportunity to review your project. I've gone through the details and prepared the information below.</p>
                            <p>As promised, you'll find a breakdown of the quoted work. I've included notes where helpful to provide additional context around certain items.</p>
                            <p>The scope of work is outlined below. If the project includes multiple components, they are presented separately so you can move forward with any portion at your discretion. When you're ready to proceed, I can provide a formal quote for approval.</p>
                        </div>

                        {/* <Accordion title="TITLE" onOpen={trackAccordionOpen}>
                        </Accordion> */}
                        <div className="quote-section">

                            <div className='quote-subsection'>
                                <div className="project-description">
                                    The objective is to address the localized rot near the valley-eave-rake transition. The existing metal roof was installed over the original shingles using only furring strips, with no secondary underlayment and no solid substrate for the drip edge to fasten to. I'll be removing a section of the roof system to install a proper secondary water barrier and a custom cleat system that bridges the gap between the original roofline and the new metal elevation, giving the trim a solid surface to fasten to.
                                </div>
                            </div>

                            <hr />

                            <div className='quote-subsection'>
                                <h3 className="section-label">Scope of work</h3>
                                <div className="white-card">
                                    <ul className="scope-list">
                                        <li><strong>Demolition:</strong> Temporarily remove existing metal panels and furring strips along the 17' rake. Strip back the rotten fascia and the original 1" drip edge. Remove approximately 6' of the damaged 21.5" wide soffit material.</li>
                                        <li><strong>Structural Inspection:</strong> Inspect rafter tails for rot. If required, "sister" the tails with new 2x material to provide a solid structural substrate for the new fascia.</li>
                                        <li><strong>Wood replacement:</strong> Replace any deteriorated fascia, subfascia, or other structural wood uncovered during demo.</li>
                                        <li><strong>Underlayment & Waterproofing:</strong> Install a high-temp, self-adhering "Ice & Water" membrane directly over the shingles and wrapped down over the face of the sub-fascia. This creates a redundant waterproof seal at the most vulnerable failure point.</li>
                                        <li><strong>The "Cleat" System:</strong> Install a custom-ripped wooden cleat to bridge the vertical gap between the old roof deck and the new metal height. This ensures the metal trim has a solid surface to fasten into, preventing "fish-mouthing" or wind-lift.</li>
                                        <li><strong>Trim Installation:</strong> Install new sub-fascia and finish fascia using rot-resistant pressure treated trim board. Install a new oversized drip edge integrated with the underlayment.</li>
                                        <li><strong>Roof Reassembly:</strong> Reinstall furring strips and re-set metal panels using new steel screws with neoprene washers. </li>
                                        <li><strong>Sealing:</strong> Install foam closure strips to match the metal profile, preventing wind-driven rain from blowing behind the trim. Seal all transitions with professional-grade OSI Quad sealant.</li>
                                        <li><strong>Haul away:</strong> Remove and dispose of all demo debris, rotten wood, and old hardware.</li>
                                    </ul>
                                    <div className="time-expectation"><strong>Time expectation:</strong> 8-12 hours, depending on the extent of wood rot found</div>
                                </div>
                            </div>

                            <hr />

                            <div className='quote-subsection'>
                                <h3 className="section-label">Materials estimate</h3>
                                <div className="white-card">
                                    <ul className="material-card-list">
                                        <li>Pine/PT Fascia & Sub-fascia: $75</li>
                                        <li>Soffit Wood: $45</li>
                                        <li>High-temp Self-adhering Underlayment: $55</li>
                                        <li>New Metal Drip Edge / Trim: $70</li>
                                        <li>Butyl-faced closure strips: $30</li>
                                        <li>Gasketed self-sealing screws: $20</li>
                                        <li>OSI Quad Sealant & Foam Closures: $30</li>
                                        <li>Misc PT Lumber for Rafter Sistering/Cleats: $40</li>
                                    </ul>
                                </div>
                                <div className="material-note">
                                    <p>Materials and equipment are billed at exact cost and a copy of all receipts will be provided.</p>
                                    <p><strong>Procurement & Delivery</strong> covers the professional selection of quality materials, time spent at suppliers, fuel, and the logistics of transporting oversized trim boards and specialized roofing components to the job site.</p>
                                </div>
                            </div>

                            <hr />

                            <div className='quote-subsection'>
                                <h3 className="section-label">Pricing</h3>
                                <div className="quote-pricing-block">
                                    <div className="pricing-row">
                                        <span className="pricing-label">Labor (flat rate):</span>
                                        <span className="pricing-value">$650</span>
                                    </div>
                                    <div className="pricing-row">
                                        <span className="pricing-label">Materials (estimated):</span>
                                        <span className="pricing-value">~$365</span>
                                    </div>
                                    <div className="pricing-row pricing-row--total">
                                        <span className="pricing-label">Estimated total:</span>
                                        <span className="pricing-value">$1,015</span>
                                    </div>
                                </div>
                                <div className="pricing-note"><p>
                                    <strong>Custom note:</strong> Wood prices and labor charge are based on my initial inspection. After beginning the work and opening the roof, additional wood rot may be uncovered, which may incur additional costs beyond what is quoted here. I will discuss with you before moving forward if so.
                                </p>
                                    Pricing includes all prep, installation, and cleanup. <strong>North Florida Home Repair & Maintenance</strong> provides a lifetime warranty on work performed. If this repair ever fails due to poor workmanship, we will fix it for free.</div>
                            </div>

                        </div>

                        <hr style={{ marginTop: '3rem' }} />
                        <h2>Next Steps</h2>
                        <p>
                            Estimates provided are valid for 30 days. For any project that requires a material order above $250, a deposit covering material costs is required prior to scheduling. Labor/remainder is due upon completion of the work.
                        </p>
                        <p>
                            <strong>Please reach out</strong> whenever you are ready to move forward or if you have any questions!
                        </p>
                    </div>
                </section>
            </main>
            <footer className="quote-footer">
                <h1>Thank you!</h1>
                <div className="footer-brand-box">
                    <img
                        src="/transparent-logo-min.png"
                        alt="North Florida Home Repair & Maintenance"
                        className="footer-logo"
                    />
                    <div className="footer-fine-print">
                        Reliable | Insured | Professional Home Services
                    </div>
                </div>
                <div className="footer-contact-info">
                    <a href="tel:9043862663" className="contact-link">
                        (904) 386-2663
                    </a>
                    <span className="contact-divider">•</span>
                    <a href="mailto:daniel@northfloridarepair.com" className="contact-link">
                        daniel@northfloridarepair.com
                    </a>
                </div>

                <div className="footer-actions">
                    <button onClick={() => navigate('/')} className='home-button'>
                        ← Return Home
                    </button>
                </div>
            </footer>
        </div >
    );
}